import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Spinner } from 'react-bootstrap';

class ProgressingButton extends Component {
  render() {
    return (
      <Button 
        id={this.props.id ? this.props.id : ""} 
        size={this.props.size ? this.props.size : "md"}
        className={this.props.className ? this.props.className : ""}
        variant={this.props.variant ? this.props.variant : "default"} 
        disabled={this.props.disabled || this.props.common.isSaving ? true : false}
        onClick={() => {
          this.props.onClick();
        }}>
          {this.props.common.isSaving ? <Spinner animation="border" size="sm" /> : this.props.buttonValue}
      </Button>
    )
  }
}

const mapStateToProps = (state) => ({
  common: state.common 
})


export default connect(mapStateToProps)(ProgressingButton)